import React from 'react'
import Navbar from 'react-bootstrap/Navbar'
import useAuth from '../routes/useAuth'
import { Button, Space, Spin, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'
import logo from '../assets/Logo/logosidetext.png'
import { ArrowRightOutlined } from '@ant-design/icons'

const LandingPageNavbar = () => {
    const { isFetching, isVerified } = useAuth()
    const navigate = useNavigate()
    const LoginAndRegisterButton = () => {
        return (
            <Space>
                <Button type="text" href="/login" style={{ textDecoration: "none" }}> Log in</Button>
                <Button type="primary" href="/register" style={{ borderRadius: "0px", textDecoration: "none" }}>Sign up</Button>
            </Space>
        )
    }

    const ContinueToCalculatorButton = () => (
        <Space>
            {/* <Button type="text" href='/home'>Continue to Calculator</Button> */}
            <Button type='text' onClick={() => navigate('/home')}>
                <Typography.Title level={3}>Continue to Calculator <ArrowRightOutlined /></Typography.Title>
            </Button>
        </Space>
    )

    return (
        <Navbar
            expand="md"
            class="row "
            id="nav"
            expanded="true"
            style={{ justifyContent: "center", backgroundColor: "white", padding: "0px 1.5rem" }}
        >
            <div style={{ width: "100%", maxWidth: "1280px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ maxWidth: "250px", width: "100%" }}>
                    <img
                        src={logo}
                        alt="logo-RealtimeLSS"
                        loading="lazy"
                        style={{ maxWidth: "100%", height: "auto", objectFit: "contain" }}
                    />
                </div>
                {
                    isFetching ? (
                        <Spin />
                    ) : (
                        isVerified ? (
                            <ContinueToCalculatorButton />
                        ) : (
                            <LoginAndRegisterButton />
                        )
                    )
                }
            </div >
        </Navbar >

    )
}

export default LandingPageNavbar
